
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Schatzker_classification_of_tibial_plateau_fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Schatzker_classification_of_tibial_plateau_fractures.vue